import { FieldPattern } from '..';

import { CONDITIONALLY_DEPENDENT_FIELD } from '../../../../constants/FieldTypeConstants';

import DependentField from '../DependentField';

class ConditionallyDependentField extends DependentField {
  readonly type: string = CONDITIONALLY_DEPENDENT_FIELD;
  dependentOnFields: string[];
  conditionallyDependentValues: Array<{
    condition: string;
    value: string;
    isConditionalValue?: boolean;
  }>;
  //TODO:Need to check and resolve error after give type fieldData
  constructor(fieldData: any, initialValue: string) {
    super(fieldData, initialValue);
    this.dependentOnFields = fieldData.dependent_on_fields ?? [];
    this.conditionallyDependentValues =
      fieldData.conditionally_dependent_values ?? [];
  }

  match<T>(p: FieldPattern<T>): T {
    return p.ConditionallyDependentField(this);
  }
}

export default ConditionallyDependentField;
